export function minute(date) {
  return new Date(date).getMinutes();
}
